import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormItemInput from "../../components/form-item/form-item-input";
import FormCard from "../../components/card/FormCard";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { requireRules } from "../../helper/method";
import { tokenMock } from "../../helper/mock";
import { $api } from "../../helper";
import { useNavigate, useParams, useSearchParams } from "react-router";
import FormItemInputNumber from "../../components/form-item/form-item-input-number";
import { Form } from "antd";

export default function AddSeason() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const params = useParams();
  const notify = useNotify();
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/course-season/",
  );
  const update = $api.useMutation("put", "/site-api/v1/course-season/");
  const detail = $api.useMutation("get", "/site-api/v1/course-season-detail/");
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد فصل");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            season_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      title: string;
      display_order: number;
    },
    redirect = true,
  ) => {
    if (!searchParams.get("u_id")) {
      mutate(
        {
          body: { ...values, course_u_id: params.id ?? "" },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate(`/list-of-seasons/${params.id}`);
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: { ...values, season_u_id: searchParams.get("u_id") ?? "" },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate(`/list-of-seasons/${params.id}`);
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      {/* <CustomBreadcrumb
        items={[
          {
            title: "مدیریت دوره ها",
            href: "/course",
          },
          {
            title: searchParams.get("name"),
            href: `/list-of-seasons/${params.id}/?name=${searchParams.get("name")}`,
          },
          {
            title: "ایجاد فصل",
          },
        ]}
      /> */}
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به فصل"
        title="اطلاعات اصلی فصل"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={requireRules("عنوان فصل")}
            className="col-span-1"
            label="عنوان فصل"
            inputProps={{
              placeholder: "لطفا عنوان فصل خود را وارد کنید.",
            }}
          />
          <FormItemInputNumber
            name={"display_order"}
            rules={requireRules("ترتیب نمایش")}
            className="col-span-1"
            label="ترتیب نمایش"
            inputProps={{
              placeholder: "لطفا ترتیب نمایش خود را وارد کنید.",
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
